import React from 'react'
import jaquar from "../images/jaquar_Uma Hardware Natna.jpg";
import jaquarblackwhite from "../images/Jaquar Black & white color.jpg";
import kajariatiles from "../images/Kajaria.png";
import somanytiles from "../images/SOMAY BANNER.jpg";
import Umatiles from "../images/UMA.jpg";
import SOMAYTILESVERIFY from "../images/SOMAY TILES VERIFY.jpg";

function Slider() {
  return (
    <div>
      <div id="carouselExampleControls" className="carousel slide" data-bs-ride="carousel">
  <div className="carousel-inner">
    <div className="carousel-item active">
      <div className='karimpurhardware'>
                                  <img src={kajariatiles} className="d-block w-100" alt="kajariatiles Karimpur"/>

      </div>
    </div>
       <div className="carousel-item">
         <div className='karimpurhardware'>
                <img src={somanytiles} className="d-block w-100" alt="best Sanitary ware in Karimpur"/>



      </div>
    </div>
    <div className="carousel-item">
         <div className='karimpurhardware'>
                <img src={jaquarblackwhite} className="d-block w-100" alt="SOMAYTILESVERIFY Karimpur, Nadia"/>

      </div>
    </div>
    <div className="carousel-item">
             <div className='karimpurhardware'>

      <img src={jaquar} className="d-block w-100" alt="Umahardware"/>
      </div>
    </div>
    <div className="carousel-item">
             <div className='karimpurhardware'>
      <img src={SOMAYTILESVERIFY} className="d-block w-100" alt="somanytiles verify karimpur"/>
      </div>
    </div>
    <div className="carousel-item">
             <div className='karimpurhardware'>
      <img src={Umatiles} className="d-block w-100" alt="Umatiles"/>
      </div>
    </div>
  </div>
  <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="prev">
    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
    <span className="visually-hidden">Previous</span>
  </button>
  <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="next">
    <span className="carousel-control-next-icon" aria-hidden="true"></span>
    <span className="visually-hidden">Next</span>
  </button>
</div>
    </div>
  )
}

export default Slider
